import brand from '@helpers/brand';
import { ButtonReset } from '@helpers/global';
import { siteWide } from '@helpers/grid';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.section `
  --sectionBackground: transparent;
  --sectionColour: ${brand.global.black};
  --sectionSpacingBottom: var(--sectionSpacing);
  --sectionSpacingTop: var(--sectionSpacing);

  scroll-margin: var(--headerHeight, 0px) 0 0;
  background-color: var(--sectionBackground);
  color: var(--sectionColour);

  &[data-flush='top'] {
    --sectionSpacingTop: 0;
  }

  &[data-flush='bottom'] {
    --sectionSpacingBottom: 0;
  }

  &[data-flush='both'] {
    --sectionSpacingTop: 0;
    --sectionSpacingBottom: 0;
  }

  &[data-variant='blue-dark'],
  &[data-variant='purple-light'],
  &[data-variant='purple-dark'] {
    --sectionColour: ${brand.global.white};
  }

  &[data-variant='blue-dark'] {
    --sectionBackground: ${brand.primary.blue.dark};
  }

  &[data-variant='account-blue'] {
    --sectionBackground: ${rgba(brand.primary.blue.light, 0.2)};
  }

  &[data-variant='grey'] {
    --sectionBackground: ${brand.primary.grey};
  }

  &[data-variant='purple-light'] {
    --sectionBackground: ${brand.primary.purple.light};
  }

  &[data-variant='purple-dark'] {
    --sectionBackground: ${brand.primary.purple.dark};
  }

  &[data-has-skip='true'] {
    overflow: hidden;
    overflow: clip;
  }
`;
const Inner = styled.div `
  ${siteWide};

  padding-top: var(--sectionSpacingTop);
  padding-bottom: var(--sectionSpacingBottom);
`;
const FocusAnchor = styled.button `
  ${ButtonReset};

  height: 0;
  width: 0;
`;
const SectionWrapperStyles = {
    Container,
    Inner,
    FocusAnchor,
};
export default SectionWrapperStyles;
